import React, { useState, useRef, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import { FaPaperPlane, FaRobot, FaUser, FaSpinner, FaBell } from 'react-icons/fa';
import api from '../../services/api';

export default function AsistenteAIPage() {
  const [mensajes, setMensajes] = useState([
    {
      rol: 'asistente',
      texto: '¡Hola! Soy tu asistente financiero virtual. Puedo ayudarte a consultar tus ingresos, gastos, comprobantes y darte recomendaciones financieras. También puedes usar el botón "Generar Alertas IA" para crear alertas automáticas basadas en tus datos financieros. ¿En qué puedo ayudarte?',
    }
  ]);
  const [input,           setInput]           = useState('');
  const [cargando,        setCargando]        = useState(false);
  const [generandoAlertas, setGenerandoAlertas] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensajes]);

  const enviar = async () => {
    if (!input.trim() || cargando) return;
    const mensaje = input.trim();
    setInput('');
    setMensajes(prev => [...prev, { rol: 'usuario', texto: mensaje }]);
    setCargando(true);
    try {
      const { data } = await api.post('/asistente/chat', { mensaje });
      setMensajes(prev => [...prev, { rol: 'asistente', texto: data.respuesta }]);
    } catch {
      setMensajes(prev => [...prev, { rol: 'asistente', texto: 'Lo siento, ocurrió un error. Intenta de nuevo.' }]);
    } finally {
      setCargando(false);
    }
  };

  const generarAlertas = async () => {
    if (generandoAlertas) return;
    setGenerandoAlertas(true);
    setMensajes(prev => [...prev, { rol: 'usuario', texto: '🔔 Generar alertas financieras automáticas' }]);
    try {
      const { data } = await api.post('/asistente/alertas');
      setMensajes(prev => [...prev, {
        rol: 'asistente',
        texto: `✅ ${data.message}\n\n${data.alertas?.map((a, i) => `**Alerta ${i+1}:** ${a.titulo}\n${a.mensaje}`).join('\n\n') || ''}`
      }]);
    } catch {
      setMensajes(prev => [...prev, { rol: 'asistente', texto: '❌ No se pudieron generar las alertas. Intenta de nuevo.' }]);
    } finally {
      setGenerandoAlertas(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviar();
    }
  };

  return (
    <Layout>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Asistente Virtual IA</h4>
          <p>Consulta tu información financiera mediante chat inteligente</p>
        </div>
        <button
          className="btn btn-warning"
          onClick={generarAlertas}
          disabled={generandoAlertas || cargando}
        >
          {generandoAlertas
            ? <><FaSpinner className="fa-spin me-2" />Generando...</>
            : <><FaBell className="me-2" />Generar Alertas IA</>
          }
        </button>
      </div>

      <div className="card card-custom" style={{ height: '75vh', display: 'flex', flexDirection: 'column' }}>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {mensajes.map((m, i) => (
            <div key={i} style={{
              display: 'flex',
              justifyContent: m.rol === 'usuario' ? 'flex-end' : 'flex-start',
              gap: 8,
              alignItems: 'flex-start',
            }}>
              {m.rol === 'asistente' && (
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  background: 'linear-gradient(135deg,#E74C3C,#C0392B)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <FaRobot color="#fff" size={14} />
                </div>
              )}
              <div style={{
                maxWidth: '70%',
                background: m.rol === 'usuario' ? '#E74C3C' : '#f5f5f5',
                color:      m.rol === 'usuario' ? '#fff'    : '#333',
                borderRadius: m.rol === 'usuario' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                padding: '10px 16px',
                fontSize: 14,
                lineHeight: 1.5,
                whiteSpace: 'pre-wrap',
              }}>
                {m.texto}
              </div>
              {m.rol === 'usuario' && (
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  background: '#2C3E50',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <FaUser color="#fff" size={14} />
                </div>
              )}
            </div>
          ))}
          {(cargando || generandoAlertas) && (
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{
                width: 32, height: 32, borderRadius: '50%',
                background: 'linear-gradient(135deg,#E74C3C,#C0392B)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <FaRobot color="#fff" size={14} />
              </div>
              <div style={{
                background: '#f5f5f5', borderRadius: '18px 18px 18px 4px',
                padding: '10px 16px', fontSize: 14, color: '#999',
              }}>
                <FaSpinner className="fa-spin" /> {generandoAlertas ? 'Generando alertas...' : 'Analizando...'}
              </div>
            </div>
          )}
          <div ref={bottomRef} />
        </div>

        <div style={{
          borderTop: '1px solid #f0f0f0',
          padding: '16px 20px',
          display: 'flex', gap: 12, alignItems: 'flex-end',
        }}>
          <textarea
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Escribe tu consulta financiera... (Enter para enviar)"
            rows={2}
            style={{
              flex: 1, border: '1px solid #e0e0e0', borderRadius: 12,
              padding: '10px 16px', resize: 'none', fontSize: 14,
              outline: 'none', fontFamily: 'inherit',
            }}
          />
          <button
            onClick={enviar}
            disabled={cargando || generandoAlertas || !input.trim()}
            style={{
              width: 44, height: 44, borderRadius: '50%', border: 'none',
              background: cargando || !input.trim() ? '#ccc' : '#E74C3C',
              color: '#fff', cursor: cargando || !input.trim() ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <FaPaperPlane size={16} />
          </button>
        </div>

      </div>
    </Layout>
  );
}